module.exports = __webpack_public_path__ + "img/single-user-grey.b9807d4.svg";